'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/template-stockists.scss');

exports.default = (0, _themeSections.register)('template-stockists', {
  onLoad: function onLoad() {},


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {}
});